import { Product } from "../models/Product";

export const REPORT_RUNNER_PRODUCT_NAME = "ReportRunner";

export const isReportRunnerProduct = (
  product: Product | null | undefined
): boolean => {
  return product?.name === REPORT_RUNNER_PRODUCT_NAME;
};
